import axios from "axios";
const PRODUCT_URL = "http://www.ccclkj.cn:2022/";

const MOCK_URL = "http://www.ccclkj.cn:2022/";
export const picurl = 'http://www.ccclkj.cn/zhibanzhang/resource/';
export const baseurl =
	process.env.NODE_ENV === "production" ? PRODUCT_URL : MOCK_URL;

export function request(config) {
	const instance = axios.create({
		baseURL: baseurl
	});
	instance.interceptors.request.use(
		config => {
			return config;
		},
		err => {
			console.log(err);
		}
	);

	instance.interceptors.response.use(
		response => {
			let res = response.data;
			console.log(res);
			if (res.code == 20000) {
				return res.data;
			} 
		},
		err => {
			console.log(err);
		}
	);
	return instance(config);
}
